import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_11 = { class: "clearfix" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\tLower Range\r\n\t\t\t", -1 /* HOISTED */);
const _hoisted_14 = { class: "invalid-feedback" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_16 = { class: "invalid-feedback" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-3 bottom10" };
const _hoisted_18 = { class: "invalid-feedback" };
const _hoisted_19 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-3 bottom10"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\tUpper Range\r\n\t\t\t", -1 /* HOISTED */);
const _hoisted_21 = { class: "invalid-feedback" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_23 = { class: "float-end float-start-sm" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _createTextVNode("Editing schedule report "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All companies",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Any site",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.batteryType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.batteryType) = $event)),
                    options: _ctx.batteryTypes,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select a Battery Type",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.getSettingsTitle), 1 /* TEXT */)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn1Val, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseColumn1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.ohmicRiseColumn1) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.ohmicRiseColumn1 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_14, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.ohmicRiseColumn1]
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", null, _toDisplayString(_ctx.column2Label), 1 /* TEXT */),
                _createTextVNode(),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn2Val, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseColumn2,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.ohmicRiseColumn2) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.ohmicRiseColumn2 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_16, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.ohmicRiseColumn2]
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", null, _toDisplayString(_ctx.column3Label), 1 /* TEXT */),
                _createTextVNode(),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn3Val, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseColumn3,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.ohmicRiseColumn3) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.ohmicRiseColumn3 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_18, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.ohmicRiseColumn3]
                ])
            ]),
            _createTextVNode(),
            (_ctx.isLeadAcid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn4Val, {
                        type: "number",
                        modelValue: _ctx.query.ohmicRiseColumn4,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.ohmicRiseColumn4) = $event)),
                        modelModifiers: { trim: true },
                        min: "0",
                        max: "100",
                        step: "1",
                        class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.ohmicRiseColumn4 }
                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_21, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                        [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.ohmicRiseColumn4]
                    ])
                ]))
                : _createCommentVNode("v-if", true),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                    _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.schedule
                    }, {
                        default: _withCtx(() => [
                            _hoisted_24,
                            _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])), [
                        [_directive_standard_or_higher]
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.exportToPdf
                    }, {
                        default: _withCtx(() => [
                            _hoisted_25,
                            _createTextVNode(" Export PDF\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.exportToCsv
                    }, {
                        default: _withCtx(() => [
                            _hoisted_26,
                            _createTextVNode(" Export CSV\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
